<template>
  <div id="Supports">
    <q-dialog persistent position="right" v-model="supportDetailDialog">
      <SupportDetail @closeSupportDetailDialog="supportDetailDialog=false" :supportId="supportId"></SupportDetail>
    </q-dialog>
    <div class="position-absolute" style="right: 15px;top:75px; z-index: 1">
      <div class="d-flex">
        <q-input class="searchBox" debounce="800" placeholder="Search" style="width: 300px" v-model="filter">
          <template v-slot:prepend>
            <q-icon name="search"/>
          </template>
        </q-input>
      </div>
    </div>
    <q-tabs align="left" class="text-primary" style="padding-left: 16px; padding-right: 16px;"
            v-model="tab">
      <template v-for="(s, index) in sArr">
        <q-tab :label="s.label +' ('+$data[s.name].length+')'" class="text-blue" :name="s.tab"></q-tab>
      </template>
    </q-tabs>
    <q-tab-panels animated v-model="tab">
      <template v-for="(s, index) in sArr">
        <q-tab-panel :name="s.tab">
          <q-table :columns="columns" :data="$data[s.name]" class="table-header"
                   flat row-key="name" table-class="table-class" @row-click="openSupportDetail">
          </q-table>
        </q-tab-panel>
      </template>
    </q-tab-panels>
  </div>
</template>

<script>
import SupportDetail from '@/components/Support/SupportDetail'
import { generate_SUBSCRIBE_SUPPORTS_BY_STATUS_AND_PARTNER } from '@/graphql/subscription/support'
import Constants from '@/Constants/Constant'
import moment from 'moment'

let sArr = [
  { name: 'newSupports', status: [Constants.SupportStatuses.New], tab: 'new', label: 'New' },
  {
    name: 'inProgressSupports', status: [Constants.SupportStatuses.InProgress],
    tab: 'inProgress', label: 'In Progress',
  },
  { name: 'onHoldSupports', status: [Constants.SupportStatuses.OnHold], tab: 'onHold', label: 'On Hold' },
  {
    name: 'waitForCustomerResponseSupports', status: [Constants.SupportStatuses.WaitForCustomerResponse],
    tab: 'waitForCustomerResponse', label: 'Wait For Customer Response',
  },
  { name: 'solvedSupports', status: [Constants.SupportStatuses.Solved], tab: 'solved', label: 'Solved' },
  { name: 'rejectedSupports', status: [Constants.SupportStatuses.Rejected], tab: 'rejected', label: 'Rejected' },
]
let sObj = {}
sArr.forEach(curnt => {
  sObj[curnt.name] = {
    query () {return generate_SUBSCRIBE_SUPPORTS_BY_STATUS_AND_PARTNER(curnt.name, this.gqlstr[this.user?.userTypeId])},
    skip () {return !this.user},
    variables () {
      return {
        status: curnt.status, filter: '%' + this.filter + '%',
        partnerId: this.currentPartner,
      }
    },
    result ({ data }) { this[curnt.name] = data[curnt.name] },
  }
})
export default {
  name: 'Supports',
  components: { SupportDetail },
  apollo: {
    $subscribe: {
      ...sObj,
    },
  },
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      currentPartner: JSON.parse(localStorage.getItem('user')).orgId,
      Constants: Constants,
      gqlstr: {
        [Constants.UserTypes.PartnerOwner]: 'OrderItem:{from:{_eq: $partnerId}},',
      },
      moment: moment,
      tab: 'new',
      sArr: sArr,
      newSupports: [],
      inProgressSupports: [],
      onHoldSupports: [],
      waitForCustomerResponseSupports: [],
      solvedSupports: [],
      rejectedSupports: [],
      supportDetailDialog: false,
      filter: '',
      columns: [
        { name: 'supportNo', label: 'ID', field: row => row.supportNo, align: 'left', sortable: true },
        { name: 'supportTitle', label: 'Title', field: row => row.title, align: 'left', sortable: true },
        { name: 'product', label: 'Product', field: row => row.Product?.name, align: 'left', sortable: true },
        {
          name: 'supportLevel', label: 'Level', field: row => row.level ? row.level : '-',
          align: 'left', sortable: true,
        },
        { name: 'assignTo', label: 'Assigned To', field: row => row.AssignTo?.name, align: 'left', sortable: true },
        { name: 'supportStatus', label: 'Status', field: row => row.Status?.name, align: 'left', sortable: true },
        {
          name: 'supportPriority', label: 'Priority', field: row => row.priority ? row.priority : '-',
          align: 'left', sortable: true,
        },
        { name: 'customerName', label: 'Customer', field: row => row.Customer?.name, align: 'left', sortable: true },
        { name: 'serialNo', label: 'Serial No.', field: row => row.serialNo, align: 'left', sortable: true },
        {
          name: 'supportPlan', label: 'Support Plan', field: row => row.SupportPlan?.name,
          align: 'left', sortable: true,
        },
        {
          name: 'isSupportPlanActive', label: 'Plan Status.',
          field: row => row.isSupportPlanActive ? 'Active' : 'Inactive', align: 'left', sortable: true,
        },
        {
          name: 'createdDate', label: 'Date', field: row => moment(row.created_at).format('DD/MM/YYYY hh:mm A'),
          align: 'left', sortable: true,
        },
      ],
      loading: false,
      supportId: null,
    }
  },
  methods: {
    openSupportDetail (evt, row) {
      console.log(1)
      this.supportId = row.id
      this.supportDetailDialog = true
    },
  },
}
</script>

<style scoped>

</style>
